var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([17bhju]|1s|4p|a2g|ef|ft|hm|j3|ot|pe|qe|qi)|n([7blqw]|1g|23k|2u|4y|57|95|c5|ia|jx|ya|ze)|2([248]|57|5k|77|7y|ci|d6|g3|hd|k4)|f([4denrvw]|2j|bm|l3|m4|ob|sl|to|wi|wn)|q(1|4j|g9e|j7|k4|mc|v0|w|x6)|w([067ehv]|1v|57|a6|cf|fe|gz|ju|ry|wb5)|z([bmtwz]|0x|51|a9|dw|f4|gc|mu|x5|zw)|o([348fhuw]|15|4n|8t|dj|fo|uh|xn|za|zc)|k(1f|1z|3|4h|89|m|q9|r2|us|xk|ya|zb)|d([cikz]|30|f6|gb|nc|pi|v7|vr)|l([bcdlu]|4t|6p|b0|h5|iy|w0|ym)|7([7apwz]|2a|2d|5z|86|a2|fa|gn|ie|j1|uw)|b([345jlmz]||kn|oc|sc|vx|w0|xt)|9([jloqy]|36|65|87|am|gn|j2|mq|p9|q6)|r(02|7a|9f|g|hk|j|n6|oo|q7|xd|zx)|0([04gjmrx]|1[5kq]|92|ag|aj|bc|d3|ig|q9|tf|vb|wl|xz|yz)|t([acq]|l(3|7|lv)|3w|51|7lm|ah|gm|ii|n9|ni|ue)|i([5cikuvw]|10|4i|99|a2|ap|b6|kr|lw|ns|r4|rz)|x([4jln]|[29h]y|4x|bv|gd|i7|l7|mx5|ph|rh|y4|yc|zc|zt)|h([17uxy]|q3(|s)|4b|a5r|ao|cx|g2|j6|kw|t8|wz)|j([45jptv]|29|7j|a4|dp|i7|jd|wb|wf)|3(71|92|fl|fp|j3|r4|wj|y|z)|s([3bhnz]|h[efs]|0a|61|a8|c1|d9|ex|kd|kj|lp|me|tz|vp)|v([9knqu]|b3|ct|fa|kh|kn|og|y0)|1([137fiow]|00|8m|8w|f1|i1|jf|mh|mu|rv|x7)|8([2dh]|e[8ks]|1s|dm|gu|hi|hw|k2|nm|ov|qc|w4|xc)|g([18wx]|2n|9s|mb|yb|yf|zt)|p([3rt]|2k|6o|ds|mx|n8|s4|yv)|4([hnv]|17|1h|76|7e|eg|ft|uu|v5|wv)|a(2r|3u|7h|7y|9o|ck|cv|do|eb|f|ik|k3|rf|wv)|5([469ekmr]|0s|1p|6n|mz|nc|s9)|c([248cjp]|kc|mi|n9|nd)|6([13gy]|19|3t|8y|96|bl|cd|co|f0|fq|gc|li|q6|v8|vy)|u([138dlp]|[muw]8|2l|gm|hn|wq|ye)|e([5fls]|2b|2f|8f|98|ah|av|hk|mz|r0|tk3|vi|vw|wc|wo)|y([fkny]|2q|7n|81|ek|ji|l8|uk))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
